import React from 'react';
import { LNBMenuType } from '../../../types/enum/LNBMenuType';
import { useHistory, useLocation } from 'react-router-dom';
import paths from '../../../commons/paths';

export interface DetailBackProps {
  lnbMenuType: LNBMenuType
}

const DetailBack = (props: DetailBackProps) => {
  const history = useHistory();
  const location = useLocation<{ fromList?: boolean }>();
  const isFromList = location.state?.fromList;

  const onClickBackToListButton = (menuType: LNBMenuType) => {
    switch(menuType){
      case LNBMenuType.VIDEO:
        history.push(paths.getPath('videoList'));
        break;
      case LNBMenuType.CARD_COMICS:
        history.push(paths.getPath('webtoonList'));
        break;
      case LNBMenuType.MAGAZINE:
        history.push(paths.getPath('cardNewsList'));
        break;
      case LNBMenuType.NEWS:
        history.push(paths.getPath('newsList'));
        break;
      case LNBMenuType.MENTIONS_BOARD:
        history.push(paths.getPath('mentionsBoardList'));
        break;
      case LNBMenuType.BOOKSTORE_BOARD:
        history.push(paths.getPath('bookstoreBoardList'));
        break;
      case LNBMenuType.SOCIETY_BOARD:
        history.push(paths.getPath('societyBoardList'));
        break;
      case LNBMenuType.TOP_EATS:
        history.push(paths.getPath('topEatsBoardList'));
        break;
      case LNBMenuType.DEPARTMENT_BOARD:
        history.push(paths.getPath('departmentBoardList'));
        break;
      case LNBMenuType.FREE:
        history.push(paths.getPath('boardList'));
        break;
      case LNBMenuType.SURVEY:
        history.push(paths.getPath('eventSurveyList'));
        break;
      case LNBMenuType.M_QUIZ:
        history.push(paths.getPath('eventQuizList'));
        break;
      case LNBMenuType.EDITOR:
        history.push(paths.getPath('eventList'));
        break;
      case LNBMenuType.QNA:
        history.push(paths.getPath('qnaList'));
        break;
      case LNBMenuType.ANNOUNCEMENT_BOARD:
        history.push(paths.getPath('announcementBoardList'));
        break;
    }
  }
  return (
    <div className="detail_back">
      <button
        className="detail_back_btn"
        onClick={() => {
          if (isFromList) {
            history.goBack();
          } else {
            onClickBackToListButton(props.lnbMenuType)
          }
        }}>
        {/* 고객 요청으로 인해 뒤로가기 대신 '목록' 이라는 문구로 변경 - 2025.09.23 */}
        {/*<img className="is-mobile" src="/assets/images/icon/ico-back-btn.png" alt="back" />*/}
        {/*<img className="is-pc" src="/assets/images/icon/ico-action-64-m-back.png" alt="back" />*/}
        <span>목록</span>
      </button>
    </div>
  );
};

export default DetailBack;
